export enum CustomerCreationMode {
    Self, ByAdministrator, Direct
}